import React, { useState } from 'react'
import Nav from './Nav'
import { IFooter } from './types'
import Slider from 'react-slick'
import Link from 'components/Link'
import { StaticImage } from 'gatsby-plugin-image'

const slides = [
    {
        label: 'Property management',
        url: '/property-management',
        image: (
            <StaticImage
                placeholder="none"
                loading="eager"
                quality={100}
                objectFit="contain"
                alt=""
                src="./images/readys/property-management.png"
            />
        ),
    },
    {
        label: 'Real estate crm',
        url: '/real-estate-crm',
        image: (
            <StaticImage
                placeholder="none"
                loading="eager"
                quality={100}
                objectFit="contain"
                alt=""
                src="./images/readys/real-estate-crm.png"
            />
        ),
    },
    {
        label: 'Real estate marketing',
        url: '/real-estate-marketing',
        image: (
            <StaticImage
                placeholder="none"
                loading="eager"
                quality={100}
                objectFit="contain"
                alt=""
                src="./images/readys/real-estate-marketing.png"
            />
        ),
    },
    {
        label: 'Mobile apps',
        url: '/real-estate-mobile-apps',
        image: (
            <StaticImage
                placeholder="none"
                loading="eager"
                quality={100}
                objectFit="contain"
                alt=""
                src="./images/readys/real-estate-mobile-apps.png"
            />
        ),
    },
    {
        label: 'Transaction-management',
        url: '/transaction-management',
        image: (
            <StaticImage
                placeholder="none"
                loading="eager"
                quality={100}
                objectFit="contain"
                alt=""
                src="./images/readys/transaction-management.png"
            />
        ),
    },
    {
        label: 'Websites',
        url: '/real-estate-websites',
        image: (
            <StaticImage
                placeholder="none"
                loading="eager"
                quality={100}
                objectFit="contain"
                alt=""
                src="./images/readys/websites.png"
            />
        ),
    },
    {
        label: 'Data warehouse',
        url: '/real-estate-platform',
        image: (
            <StaticImage
                placeholder="none"
                loading="eager"
                quality={100}
                objectFit="contain"
                alt=""
                src="./images/readys/sql.png"
            />
        ),
    },
    {
        label: 'Real Estate pipelines',
        url: '/real-estate-platform',
        image: (
            <StaticImage
                placeholder="none"
                loading="eager"
                quality={100}
                objectFit="contain"
                alt=""
                src="./images/readys/event-pipelines.png"
            />
        ),
    },
    {
        label: 'API',
        url: '/real-estate-platform',
        image: (
            <StaticImage
                placeholder="none"
                loading="eager"
                quality={100}
                objectFit="contain"
                alt=""
                src="./images/readys/api.png"
            />
        ),
    },
    {
        label: 'Data warehouse',
        url: '/real-estate-platform',
        image: (
            <StaticImage
                placeholder="none"
                loading="eager"
                quality={100}
                objectFit="contain"
                alt=""
                src="./images/readys/data-tree.png"
            />
        ),
    },
    {
        label: 'Data warehouse',
        url: '/real-estate-platform',
        image: (
            <StaticImage
                placeholder="none"
                loading="eager"
                quality={100}
                objectFit="contain"
                alt=""
                src="./images/readys/data-tractor.png"
            />
        ),
    },
    {
        label: 'Data warehouse',
        url: '/real-estate-platform',
        image: (
            <StaticImage
                placeholder="none"
                loading="eager"
                quality={100}
                objectFit="contain"
                alt=""
                src="./images/readys/data-warehouse.png"
            />
        ),
    },
    {
        label: 'Data warehouse',
        url: '/real-estate-platform',
        image: (
            <StaticImage
                placeholder="none"
                loading="eager"
                quality={100}
                objectFit="contain"
                alt=""
                src="./images/readys/warehouse-sync.png"
                className="max-h-[300px]"
            />
        ),
    },
]

const sliderSettings = {
    dots: false,
    infinite: true,
    arrows: false,
    slidesToScroll: 11,
    autoplay: true,
    variableWidth: true,
    autoplaySpeed: 0,
    speed: 100000,
    cssEase: 'linear',
}

const Slide = ({ image, label }: { image: React.ReactNode; label: string }) => {
    return (
        <div className="group relative">
            <div className="relative transition-transform hover:scale-[1.1] active:scale-[1.09]">{image}</div>
            <div className="invisible absolute left-0 bottom-4 right-0 flex justify-center group-hover:visible">
                <span className=" rounded-md bg-tan/75 px-3 text-lg shadow-xl backdrop-blur">{label}</span>
            </div>
        </div>
    )
}

export default function Footer({ title }: IFooter) {
    const [activeSlide, setActiveSlide] = useState(0)

    return (
        <section className="my-14 text-center">
            <h2 className="text-4xl md:text-6xl">iCloudReady does that.</h2>
            <p className="mt-2 mb-12">
                Now that you know iCloudReady does {title.toLowerCase()}, check out what else iCloudReady can do.
            </p>
            <Nav />
            <div className="-mx-5 -mb-20 pt-28">
                <Slider
                    beforeChange={(_oldIndex, newIndex) => setActiveSlide(newIndex)}
                    className="product-readys-slider"
                    {...sliderSettings}
                >
                    {slides.map((slide, index) => {
                        return (
                            <Link key={index} className="cursor-pointer" to={slide.url}>
                                <Slide {...slide} />
                            </Link>
                        )
                    })}
                </Slider>
            </div>
        </section>
    )
}
